import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_SURVEYS } from '@/api/endpoints';
import { SURVEY_QUERY_KEY } from '@/api/queryKeys';
import { toSurvey } from '@/pages/Mail/surveys';
import type { Survey, SurveyResponse } from '@/types/survey';
import { unwrapAxiosResponse } from '@/utils/axios';
import { joinPath } from '@/utils/global';

export const useSurvey = (surveyId: string) =>
  useQuery<Survey>({
    queryKey: [...SURVEY_QUERY_KEY, surveyId],
    queryFn: () =>
      apiClient
        .get<SurveyResponse>(joinPath(API_SURVEYS, surveyId))
        .then(unwrapAxiosResponse)
        .then(toSurvey),
  });
